class CartGoalEmbedNew {
  PROXY_URL = "apps/salepify";
  API_VERSION = "2025-01";
  PROPERTY = "_salepify-progress-bar";
  SUBTOTAL_PROPERTY = "_salepify-progress-bar-subtotal";
  IMPRESSION_KEY = "salepify_progress_bar_impressions";
  CART_GOAL_REWARD_STACK = {
    ALL_MILESTONES: "all",
    ONLY_LASTEST_MILESTONE: "lastest"
  };
  CART_GOAL_REWARD_TYPE = {
    FREE_GIFT: "gift",
    CART_DISCOUNT: "discount",
    FREE_SHIPPING: "free_ship"
  };
  CART_GOAL_POSITION = {
    BEFORE: "before",
    AFTER: "after",
    PREPEND: "prepend"
  };
  INCLUSION_TYPE = {
    INCLUDE: "include",
    EXCLUDE: "exclude"
  };
  CUSTOMER_STATUS = {
    NOT_LOGGED: "not_logged",
    LOGGED_IN: "logged_in"
  };
  DEFAULT_STYLE_PROGRESS_BAR = {
    title_label: "#303030",
    milestone_label: "#303030",
    filled_bar: "#9e58bb",
    filter_bar_color: "invert(44%) sepia(24%) saturate(1498%) hue-rotate(238deg) brightness(90%) contrast(81%)"
  };
  DEFAULT_STYLE_CONTAINER = {
    background_color: "#ffffff",
    border_color: "#303030",
    border_radius: 0,
    border_width: 0,
    opacity: 1,
    reward_text_color: "#303030"
  };
  DEFAULT_STYLE_GIFT_MODAL = {
    background_color: "#ffffff",
    border_color: "#9e58bb",
    button_color: "#9e58bb",
    check_box_color: "#9e58bb",
    free_text_color: "#9e58bb",
    border_width: 0,
    border_radius: 5
  };
  DEFAULT_STYLE_SECTION_REWARD = {
    button_color: "#9e58bb",
    button_selected_color: "#d9cdcd",
    hide_claim_reward: false
  };
  DEFAULT_STYLE_COUNTDOWN_TIMER = {
    title: {
      color: "#000000",
      font_size: 14,
      font_weight: 700
    },
    number: {
      color: "#000000",
      font_size: 24,
      font_weight: 400
    },
    label: {
      color: "#000000",
      font_size: 12,
      font_weight: 400
    }
  };
  TRIGGER_CONDITION = {
    ALL: "all",
    COLLECTION: "collection",
    PRODUCT: "product"
  };
  PURCHASE_TYPE = {
    BOTH: "both",
    ONE_TIME_PURCHASE: "one_time_purchase",
    SUBSCRIPTION: "subscription"
  };
  DEFAULT_TRANSLATION = {
    achieve_all: "Congratulations! you have achieved all milestones",
    auto_apply_btn: {
      gift: "Reward Claimed",
      order_discount: "Reward Claimed",
      shipping_discount: "Reward Claimed"
    },
    manual_apply_btn: {
      gift: {
        before_apply: "Select gifts",
        after_apply: "Selected gifts"
      },
      order_discount: {
        before_apply: "Apply Code",
        after_apply: "Applied Code"
      },
      shipping_discount: {
        before_apply: "Apply Code",
        after_apply: "Applied Code"
      }
    },
    gift_modal: {
      title: "You can choose any {{amount}} rewards",
      free_text_content: "Free",
      confirm_btn: "Confirm",
      cancel_btn: "Cancel",
      warning_msg: "Select up to {{amount}} items only",
      out_of_stock_msg: "Out of stock"
    },
    countdown_timer: {
      title: "Hurry! Offer ends in",
      days: "DAYS",
      hours: "HRS",
      minutes: "MINS",
      seconds: "SECS"
    }
  };
  STORE_ACCESS_TOKEN_KEY = "salepify_store_access_token";
  #storeAccessToken;
  #cartGoal;
  #milestones;
  #customColor;
  #containerStyle;
  #sectionRewardStyle;
  #giftModalStyle;
  #countdownStyle;
  #cartDrawDisplay;
  #cartDisplay;
  #currencyFormat;
  #currencyDisplay;
  #translation;
  constructor(isRestricted, cartGoalRules, giftSVG, discountSVG, freeShippingSVG, currencySymbol, cartTotal, template, defaultImage, showTrademark, productIdMapCollection, displaySettings, translation, customer, cartType, priceCalculation) {
    this.giftSVG = giftSVG;
    this.discountSVG = discountSVG;
    this.freeShippingSVG = freeShippingSVG;
    this.template = template;
    this.defaultImage = defaultImage;
    this.showTrademark = showTrademark;
    this.productIdMapCollection = new Map(productIdMapCollection);
    this.customer = customer;
    this.cartType = cartType;
    this.currency = currencySymbol;
    this.currencyRate = 1;
    if (Shopify && Shopify.currency) {
      this.currency = Shopify.currency.active;
      this.currencyRate = Number(Shopify.currency.rate);
    }
    this.locale = Shopify?.locale || "en";
    this.cartItems = [];
    this.cartTotal = cartTotal;
    this.#cartGoal = {};
    this.#milestones = [];
    this.infoLocation = null;
    this.isCalcByDiscountedPrice = priceCalculation?.progress_bar;
    this.getItemPrice = this.getItemPriceFactory();
    const listRule = Object.entries(cartGoalRules).map(([id, ruleData]) => ({ id: id.split("_")[0], ...ruleData }));
    this.filterRule(listRule).then(() => {
      if (Object.keys(this.#cartGoal).length) {
        if (isRestricted) {
          this.#cartGoal.milestones = this.#cartGoal.milestones.map((milestone) => ({
            ...milestone,
            title: {
              default: milestone.title.default
            },
            reward_description: {
              default: milestone.reward_description.default
            },
            reward_description_after: {
              default: milestone.reward_description_after.default
            }
          }));
          this.#customColor = this.DEFAULT_STYLE_PROGRESS_BAR;
          this.#containerStyle = this.DEFAULT_STYLE_CONTAINER;
          this.#sectionRewardStyle = this.DEFAULT_STYLE_SECTION_REWARD;
          this.#giftModalStyle = this.DEFAULT_STYLE_GIFT_MODAL;
          this.#countdownStyle = this.DEFAULT_STYLE_COUNTDOWN_TIMER;
          this.#cartDrawDisplay = {
            selector: "",
            position: this.CART_GOAL_POSITION.BEFORE
          };
          this.#cartDisplay = {
            selector: "",
            position: this.CART_GOAL_POSITION.BEFORE
          };
          this.#currencyFormat = "amount_with_period_and_space_separator";
          this.#currencyDisplay = {};
          this.#translation = this.DEFAULT_TRANSLATION;
        } else {
          if (displaySettings && displaySettings.progress_bar) {
            this.#customColor = displaySettings.progress_bar.progress_bar_style;
            this.#containerStyle = this.deepMergeObject(this.DEFAULT_STYLE_CONTAINER, displaySettings.progress_bar.container_style);
            this.#sectionRewardStyle = displaySettings.progress_bar.section_reward_style;
            this.#giftModalStyle = displaySettings.progress_bar.gift_modal_style;
            this.#countdownStyle = displaySettings.progress_bar.countdown_timer ?? this.DEFAULT_STYLE_COUNTDOWN_TIMER;
            this.#cartDrawDisplay = displaySettings.progress_bar.cart_draw_display;
            this.#cartDisplay = displaySettings.progress_bar.cart_display;
            this.#currencyFormat = displaySettings.progress_bar.currency_format;
            this.#currencyDisplay = displaySettings.progress_bar.currency_display;
          } else {
            this.#customColor = this.#cartGoal?.color ? JSON.parse(this.#cartGoal.color) : this.DEFAULT_STYLE_PROGRESS_BAR;
            this.#containerStyle = this.#cartGoal?.container_style ? JSON.parse(this.#cartGoal.container_style) : this.DEFAULT_STYLE_CONTAINER;
            this.#sectionRewardStyle = this.#cartGoal?.section_reward_style ? JSON.parse(this.#cartGoal.section_reward_style) : this.DEFAULT_STYLE_SECTION_REWARD;
            this.#giftModalStyle = this.#cartGoal?.gift_modal_style ? JSON.parse(this.#cartGoal.gift_modal_style) : this.DEFAULT_STYLE_GIFT_MODAL;
            this.#cartDrawDisplay = JSON.parse(this.#cartGoal.cart_draw_display);
            this.#cartDisplay = JSON.parse(this.#cartGoal.cart_display);
            this.#currencyFormat = this.#cartGoal.currency_format;
            this.#currencyDisplay = JSON.parse(this.#cartGoal.currency_display || "{}");
            this.#countdownStyle = this.DEFAULT_STYLE_COUNTDOWN_TIMER;
          }
          let customTranslation = null;
          if (translation) {
            const translationWithLocale = translation.progress_bar[this.locale];
            customTranslation = translationWithLocale ? translationWithLocale[this.#cartGoal.id] || {
              ...translationWithLocale,
              achieve_all: translationWithLocale?.milestone?.achieve_all
            } : null;
          } else {
            let sectionRewardStyle = this.#cartGoal?.section_reward_style ? JSON.parse(this.#cartGoal.section_reward_style) : this.DEFAULT_STYLE_SECTION_REWARD;
            let giftModalStyle = this.#cartGoal?.gift_modal_style ? JSON.parse(this.#cartGoal.gift_modal_style) : this.DEFAULT_STYLE_GIFT_MODAL;
            customTranslation = {
              achieve_all: this.#cartGoal.achieve_title,
              auto_apply_btn: {
                gift: sectionRewardStyle.selected_gifts_button_text,
                order_discount: sectionRewardStyle.apply_order_discount_button_text?.applied,
                shipping_discount: sectionRewardStyle.apply_shipping_discount_button_text?.applied
              },
              manual_apply_btn: {
                gift: {
                  before_apply: sectionRewardStyle.select_gifts_button_text,
                  after_apply: sectionRewardStyle.selected_gifts_button_text
                },
                order_discount: {
                  before_apply: sectionRewardStyle.apply_order_discount_button_text?.unapply,
                  after_apply: sectionRewardStyle.apply_order_discount_button_text?.applied
                },
                shipping_discount: {
                  before_apply: sectionRewardStyle.apply_shipping_discount_button_text?.unapply,
                  after_apply: sectionRewardStyle.apply_shipping_discount_button_text?.applied
                }
              },
              gift_modal: {
                title: giftModalStyle.title,
                free_text_content: giftModalStyle.free_text_content,
                confirm_btn: giftModalStyle.confirm_button_content,
                cancel_btn: giftModalStyle.cancel_button_content,
                warning_msg: giftModalStyle.warning_message
              }
            };
          }
          this.#translation = customTranslation ? this.deepMergeObject(this.DEFAULT_TRANSLATION, customTranslation) : this.DEFAULT_TRANSLATION;
        }
        if (this.#cartGoal.milestones) {
          const getMilestoneTranslation = (value) => {
            return typeof value == "object" ? value[this.locale] || value.default : value;
          };
          this.#milestones = this.#cartGoal.milestones.map((milestone) => ({
            ...milestone,
            cart_value: milestone.cart_value * this.currencyRate,
            reward_value: milestone.discount_type === "decrease_amount" && milestone.reward_type !== this.REWARD_TYPE.FREE_GIFT ? milestone.reward_value * this.currencyRate : milestone.reward_value,
            title: getMilestoneTranslation(milestone.title),
            reward_description: getMilestoneTranslation(milestone.reward_description),
            reward_description_after: getMilestoneTranslation(milestone.reward_description_after)
          }));
        }
        this.gifts = [];
        this.position = [];
        this.itemIdsInCart = [];
        this.passedMilestone = {
          gift: -1,
          indexOfPassedFreeGift: -1,
          freeShipping: -1,
          discount: -1,
          lastest: -1
        };
        this.appliedDiscounts = [];
        this.milestoneIndexMapGift = /* @__PURE__ */ new Map();
        this.milestoneIndexInGiftsList = /* @__PURE__ */ new Map();
        this.giftWithoutDiscount = {};
        this.giftsWithDiscount = /* @__PURE__ */ new Map();
        const { rootSelectorElement, rootSelectorElementWithEmptyCart } = tlGetRootSelectorElement();
        this.rootSelectorElement = rootSelectorElement;
        this.rootSelectorElementWithEmptyCart = rootSelectorElementWithEmptyCart;
        const { rootSelectorPosition, rootSelectorPositionWithEmptyCart } = tlGetRootSelectorPosition();
        this.rootSelectorPosition = rootSelectorPosition;
        this.rootSelectorPositionWithEmptyCart = rootSelectorPositionWithEmptyCart;
        this.discountCode = {
          product_discount: JSON.parse(this.#cartGoal.product_discount).code,
          order_discount: JSON.parse(this.#cartGoal.order_discount).code,
          shipping_discount: JSON.parse(this.#cartGoal.shipping_discount).code
        };
        this.applyCustomCss(displaySettings, isRestricted);
        this.applyCustomStyle();
        this.getCartGoalsMarginValues();
        this.initializeLocalStorage();
        this.#getStoreAccess();
        this.getDataFromAjax().then(() => {
          this.is_cart_auto_update = window.tlCheckCartAutoUpdateSupported ? window.tlCheckCartAutoUpdateSupported() : true;
          this.getPassedMilestone(this.cartTotal, true);
          this.renderAllCartGoals();
          if (this.#cartGoal.auto_remove_gift && this.milestoneIndexMapGift.size && !this.appliedDiscounts.includes(this.discountCode.product_discount)) {
            let cartTotalIncludeGift = this.cartTotal;
            this.getPassedMilestone(cartTotalIncludeGift);
          }
        });
        tlCartGoalEmbedOverride();
        this.trackImpression();
        this.updateCartAttribute(this.PROPERTY, [this.cartGoal.name, ...Object.values(this.discountCode)].join(","));
        tlHandleFirstLoad();
      }
    });
  }
  get cartGoal() {
    return structuredClone(this.#cartGoal);
  }
  get milestones() {
    return structuredClone(this.#milestones);
  }
  get customColor() {
    return structuredClone(this.#customColor);
  }
  get containerStyle() {
    return structuredClone(this.#containerStyle);
  }
  get sectionRewardStyle() {
    return structuredClone(this.#sectionRewardStyle);
  }
  get giftModalStyle() {
    return structuredClone(this.#giftModalStyle);
  }
  get cartDrawDisplay() {
    return structuredClone(this.#cartDrawDisplay);
  }
  get cartDisplay() {
    return structuredClone(this.#cartDisplay);
  }
  get currencyFormat() {
    return structuredClone(this.#currencyFormat);
  }
  get currencyDisplay() {
    return structuredClone(this.#currencyDisplay);
  }
  get translation() {
    return structuredClone(this.#translation);
  }
  applyCustomCss = (displaySettings, isRestricted) => {
    if (!isRestricted && displaySettings && displaySettings.progress_bar && displaySettings.progress_bar.custom_css && displaySettings.progress_bar.custom_css.trim() !== "") {
      var styleElement = document.getElementById("tl_custom_css_progress_bar");
      if (!styleElement) {
        styleElement = document.createElement("style");
        styleElement.id = "tl_custom_css_progress_bar";
        document.head.appendChild(styleElement);
      }
      styleElement.innerHTML = displaySettings.progress_bar.custom_css;
    }
  };
  initializeLocalStorage = () => {
    const initialTime = (/* @__PURE__ */ new Date()).getTime() + 24 * 3600 * 1e3;
    let initialData = {
      claimed_shipping_reward: false,
      expired: initialTime
    };
    let tlCartGoalLocalStorage = localStorage.getItem(LOCAL_STORAGE);
    if (!tlCartGoalLocalStorage || this.cartTotal <= 0) {
      localStorage.setItem(LOCAL_STORAGE, JSON.stringify(initialData));
    } else {
      let tlCartGoalLocalStorageData = JSON.parse(tlCartGoalLocalStorage);
      let expiredTime = tlCartGoalLocalStorageData.expired || 0;
      if ((/* @__PURE__ */ new Date()).getTime() > expiredTime) {
        localStorage.setItem(LOCAL_STORAGE, JSON.stringify(initialData));
      } else {
        tlCartGoalLocalStorageData.expired = initialTime;
        localStorage.setItem(LOCAL_STORAGE, JSON.stringify(tlCartGoalLocalStorageData));
      }
    }
  };
  addTrackImpressionEvent = () => {
    if (this.template == "cart")
      return;
    const progressBarEle = document.querySelectorAll(".tl__cart-goal__container__drawer");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const count = window.sessionStorage.getItem(this.IMPRESSION_KEY) ? Number(window.sessionStorage.getItem(this.IMPRESSION_KEY)) : 0;
            window.sessionStorage.setItem(this.IMPRESSION_KEY, count + 1);
          }
        });
      },
      { threshold: 0.5 }
    );
    progressBarEle.forEach((progressBar) => observer.observe(progressBar));
  };
  trackImpression() {
    if (this.template == "cart") {
      window.sessionStorage.setItem(this.IMPRESSION_KEY, 1);
    } else {
      window.sessionStorage.setItem(this.IMPRESSION_KEY, 0);
    }
    window.addEventListener("beforeunload", () => {
      let date = /* @__PURE__ */ new Date();
      date.setHours(0, 0, 0, 0);
      date = Math.floor(date.getTime() / 1e3);
      const count = window.sessionStorage.getItem(this.IMPRESSION_KEY) ? Number(window.sessionStorage.getItem(this.IMPRESSION_KEY)) : 0;
      if (count == 0)
        return;
      fetch(window.Shopify.routes.root + `${this.PROXY_URL}/impressions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          count,
          module: "progress_bar",
          date,
          offer_ids: [this.#cartGoal.id]
        })
      });
    });
  }
  getCartGoalsMarginValues = () => {
    let n = this.#milestones.length;
    let marginValues = Array(n).fill(0);
    marginValues[0] = 10;
    marginValues[n - 1] = 99;
    let dx = 90 / (n - 1);
    for (let i = 1; i < n - 1; i++) {
      marginValues[i] = Math.ceil(10 + dx * i);
    }
    return marginValues;
  };
  updateCartAttribute = async (attr, value) => {
    var formData = new FormData();
    formData.append(`attributes[${attr}]`, value);
    await fetch(window.Shopify.routes.root + "cart/update.js?app=salepify", {
      method: "POST",
      body: formData
    });
  };
  #getStoreAccess = async () => {
    let storeAccessToken = localStorage.getItem(this.STORE_ACCESS_TOKEN_KEY);
    if (storeAccessToken) {
      this.#storeAccessToken = storeAccessToken;
      return;
    }
    const getShopAccessReq = await fetch(window.Shopify.routes.root + `${this.PROXY_URL}/shop`);
    const getShopAccessRes = await getShopAccessReq.json();
    storeAccessToken = getShopAccessRes.data;
    localStorage.setItem(this.STORE_ACCESS_TOKEN_KEY, storeAccessToken);
    this.#storeAccessToken = storeAccessToken;
  };
  updateCartDiscountCodes = async (discounts) => {
    const request = await fetch(window.Shopify.routes.root + "cart/update.js?app=salepify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ discount: discounts.join(",") })
    });
    return await request.json();
  };
  // #logger = async (message, data) => {
  //     await fetch(window.Shopify.routes.root + `${this.PROXY_URL}/shop/client-logs`, {
  //         method: 'POST',
  //         headers: {
  //             "Accept": 'application/json',
  //             "Content-Type": 'application/json'
  //         },
  //         body: JSON.stringify({
  //             shopify_domain: window.Shopify.shop,
  //             module: "Progress bar",
  //             message,
  //             data
  //         })
  //     });
  // }
  getVariantData = async (nonGlobalId) => {
    const idBase64 = btoa(`gid://shopify/ProductVariant/${nonGlobalId}`);
    try {
      const getVariantReq = await fetch(`https://${Shopify.shop}/api/${this.API_VERSION}/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.#storeAccessToken
        },
        body: JSON.stringify({
          query: ` query {
                        node(id: "${idBase64}") {
                            ... on ProductVariant {
                                product {
                                    id
                                    collections(first: 250){
                                        nodes {
                                            id
                                        }
                                    }
                                }
                            }
                        }
                    }`
        })
      });
      const getVariantRes = await getVariantReq.json();
      if (getVariantRes.data) {
        const listCollectionId = [];
        getVariantRes.data.node.product.collections.nodes.map((collection) => {
          listCollectionId.push(collection.id.split("/").pop());
        });
        const productId = getVariantRes.data.node.product.id.split("/").pop();
        this.productIdMapCollection.set(productId, listCollectionId);
        return getVariantRes.data.node;
      } else {
        return null;
      }
    } catch (error) {
      console.log("Error when getVariantData - Cart Goal: ", error);
    }
  };
  // Get correct item price buy price calculation setting
  getItemPriceFactory = () => {
    return this.isCalcByDiscountedPrice ? (item) => item.line_price : (item) => item.original_line_price;
  };
  // Check purchase type of item
  checkPurchaseType = (itemData) => {
    const { BOTH, ONE_TIME_PURCHASE, SUBSCRIPTION } = this.PURCHASE_TYPE;
    const purchaseType = this.#cartGoal.purchase_type;
    if (purchaseType == BOTH) {
      return true;
    } else if (purchaseType == ONE_TIME_PURCHASE) {
      return !itemData.selling_plan_allocation;
    } else if (purchaseType == SUBSCRIPTION) {
      return !!itemData.selling_plan_allocation;
    }
    return true;
  };
  updateCartTotal = () => {
    if (Object.keys(this.#cartGoal).length) {
      fetch("/cart.js").then((res) => res.json()).then(async (data) => {
        this.cartItems = data.items;
        const validItem = data.items.find((item) => !isNaN(item.price / item.presentment_price));
        const ratio = validItem ? validItem.price / validItem.presentment_price : 1;
        this.itemIdsInCart = [];
        this.milestoneIndexMapGift = /* @__PURE__ */ new Map();
        this.giftWithoutDiscount = {};
        let totalAmount = 0;
        let triggerConditionIds = JSON.parse(this.#cartGoal.trigger_condition_ids);
        triggerConditionIds = triggerConditionIds.map((a) => a.shopify_id);
        this.giftsWithDiscount.clear();
        if (this.#cartGoal.trigger_condition == this.TRIGGER_CONDITION.PRODUCT) {
          data.items.forEach((item) => {
            const productId = String(item.product_id);
            const isValidItem = !this.checkIsGift(item) && triggerConditionIds.includes(productId) && this.checkPurchaseType(item);
            if (isValidItem) {
              const shouldExcludeInTotal = this.#cartGoal.auto_remove_gift && item.properties?.[this.PROPERTY];
              if (!shouldExcludeInTotal) {
                totalAmount += this.getItemPrice(item) / ratio;
              }
            }
            this.itemIdsInCart.push(String(item.id));
          });
        } else if (this.#cartGoal.trigger_condition == this.TRIGGER_CONDITION.COLLECTION) {
          const setCollectionIds = new Set(triggerConditionIds);
          for (let i = 0; i < data.items.length; i++) {
            const item = data.items[i];
            const itemId = String(item.id);
            const isValidItem = !this.checkIsGift(item) && this.checkPurchaseType(item);
            if (isValidItem) {
              const productId = String(item.product_id);
              let collections = this.productIdMapCollection.get(productId);
              if (!collections) {
                await this.getVariantData(itemId);
                collections = this.productIdMapCollection.get(productId);
              }
              if (collections) {
                if (collections.some((item2) => setCollectionIds.has(item2))) {
                  const shouldExcludeInTotal = this.#cartGoal.auto_remove_gift && item.properties?.[this.PROPERTY];
                  if (!shouldExcludeInTotal) {
                    totalAmount += this.getItemPrice(item) / ratio;
                  }
                }
              }
            }
            this.itemIdsInCart.push(itemId);
          }
        } else {
          data.items.map((item) => {
            const isValidItem = !this.checkIsGift(item) && this.checkPurchaseType(item);
            if (isValidItem) {
              const shouldExcludeInTotal = this.#cartGoal.auto_remove_gift && item.properties?.[this.PROPERTY];
              if (!shouldExcludeInTotal) {
                totalAmount += this.getItemPrice(item) / ratio;
              }
            }
            this.itemIdsInCart.push(String(item.id));
          });
        }
        let giftVariants = this.gifts[this.passedMilestone.indexOfPassedFreeGift];
        if (giftVariants) {
          this.position[this.passedMilestone.gift] = [];
          for (let i = 0; i < giftVariants.length; i++) {
            this.itemIdsInCart.forEach((item) => {
              if (giftVariants[i].id == item) {
                this.position[this.passedMilestone.gift].push(i);
              }
            });
          }
        }
        const progressBarDiscount = Object.values(this.discountCode);
        this.appliedDiscounts = data.discount_codes.filter((discount) => progressBarDiscount.includes(discount.code)).map((discount) => discount.code);
        await this.assignCartTotal(totalAmount);
        this.updateCheckpointColors();
        this.getPassedMilestone();
        this.trackingCartDrawerWhenAddtoCart();
      });
      this.renderAllCartGoals();
    }
  };
  assignCartTotal = async (newCartTotal) => {
    this.cartTotal = newCartTotal;
    if (this.isCalcByDiscountedPrice) {
      await this.updateCartAttribute(this.SUBTOTAL_PROPERTY, newCartTotal);
    }
  };
  trackingCartDrawerWhenAddtoCart = () => {
    this.updateAllCartGoals();
    let targetNode;
    const MAX_PARENTS_LEVEL = 2;
    let currentLevel = 1;
    if (this.#cartDrawDisplay.selector) {
      targetNode = document.querySelector(this.#cartDrawDisplay.selector);
    } else {
      targetNode = document.querySelector(this.rootSelectorElement);
    }
    while (targetNode && currentLevel <= MAX_PARENTS_LEVEL) {
      targetNode = targetNode.parentElement;
      currentLevel++;
    }
    const config = { attributes: true, childList: true, subtree: true };
    let timeID;
    const callback = (mutationList, observer) => {
      clearTimeout("timeID", timeID);
      if (mutationList.length) {
        if (mutationList[0].target.className.includes("tl__cart-goal__gift-modal") || mutationList[0].target.className.includes("tl__cart-goal__check-box")) {
          observer.disconnect();
        } else {
          timeID = setTimeout(() => {
            this.updateAllCartGoals();
            observer.disconnect();
          }, 500);
        }
      }
    };
    if (targetNode) {
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
  };
  hexToRgba(hex, alpha) {
    hex = hex.replace(/^#/, "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    if (alpha === void 0 || alpha === null) {
      alpha = 1;
    }
    return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(2)})`;
  }
  applyCustomStyle() {
    if (Object.keys(this.#customColor).length) {
      document.documentElement.style.setProperty("--tl__cart-goal__filled-bar-color", this.hexToRgba(this.#customColor.filled_bar, this.#customColor.opacity));
      document.documentElement.style.setProperty("--tl__cart-goal__filter-bar-color", this.#customColor.filter_bar_color);
      document.documentElement.style.setProperty("--tl__cart-goal__milestone-label-color", this.hexToRgba(this.#customColor.milestone_label, this.#customColor.opacity_milestone_label));
      document.documentElement.style.setProperty("--tl__cart-goal__title_label-color", this.hexToRgba(this.#customColor.title_label, this.#customColor.opacity_title_label));
    }
    if (Object.keys(this.#containerStyle).length) {
      document.documentElement.style.setProperty("--tl__cart-goal__container__background", this.hexToRgba(this.#containerStyle.background_color, this.#containerStyle?.opacity ? this.#containerStyle.opacity : 1));
      document.documentElement.style.setProperty("--tl__cart-goal__container__border-color", this.hexToRgba(this.#containerStyle.border_color, this.#containerStyle.opacity_border));
      document.documentElement.style.setProperty("--tl__cart-goal__container__border-width", `${this.#containerStyle.border_width}px`);
      document.documentElement.style.setProperty("--tl__cart-goal__container__border-radius", `${this.#containerStyle.border_radius}px`);
      document.documentElement.style.setProperty("--tl__cart-goal__container__reward-text-color", this.#containerStyle.reward_text_color);
    }
    if (Object.keys(this.#sectionRewardStyle).length) {
      document.documentElement.style.setProperty("--tl__cart-goal__section-reward__button-color", this.hexToRgba(this.#sectionRewardStyle.button_color, this.#sectionRewardStyle.opacity));
      document.documentElement.style.setProperty("--tl__cart-goal__section-reward__button-selected-color", this.hexToRgba(this.#sectionRewardStyle.button_selected_color, this.#sectionRewardStyle.opacity_button_selected));
    }
    if (Object.keys(this.#giftModalStyle).length) {
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__free-text", this.hexToRgba(this.#giftModalStyle.free_text_color, this.#giftModalStyle.opacity_free_text));
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__check-box", this.hexToRgba(this.#giftModalStyle.check_box_color, this.#giftModalStyle.opacity_check_box));
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__background", this.hexToRgba(this.#giftModalStyle.background_color, this.#giftModalStyle.opacity));
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__button-color", this.hexToRgba(this.#giftModalStyle.button_color, this.#giftModalStyle.opacity_button));
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__border-color", this.hexToRgba(this.#giftModalStyle.border_color, this.#giftModalStyle.opacity_border));
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__border-width", `${this.#giftModalStyle.border_width}px`);
      document.documentElement.style.setProperty("--tl__cart-goal__gift-modal__border-radius", `${this.#giftModalStyle.border_radius}px`);
    }
    if (Object.keys(this.#countdownStyle).length) {
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-title__color", `${this.#countdownStyle.title.color}`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-title__font-size", `${this.#countdownStyle.title.font_size}px`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-title__font-weight", `${this.#countdownStyle.title.font_weight}`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-number__color", `${this.#countdownStyle.number.color}`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-number__font-size", `${this.#countdownStyle.number.font_size}px`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-number__font-weight", `${this.#countdownStyle.number.font_weight}`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-label__color", `${this.#countdownStyle.label.color}`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-label__font-size", `${this.#countdownStyle.label.font_size}px`);
      document.documentElement.style.setProperty("--tl-cart-goal__countdown-label__font-weight", `${this.#countdownStyle.label.font_weight}`);
    }
  }
  getProcessBarWidth = () => {
    let marginValues = this.getCartGoalsMarginValues();
    let nextMilestone;
    let currentMilestone;
    for (let i = 0; i < this.#milestones.length; i++) {
      nextMilestone = i;
      if (this.cartTotal <= this.#milestones[i].cart_value) {
        break;
      }
    }
    currentMilestone = nextMilestone - 1;
    if (this.cartTotal >= this.#milestones[this.#milestones.length - 1].cart_value) {
      return marginValues[this.#milestones.length - 1];
    }
    if (currentMilestone > -1) {
      let distanceBetweenTwoMilestones = this.#milestones[nextMilestone].cart_value - this.#milestones[currentMilestone].cart_value;
      return marginValues[currentMilestone] + (this.cartTotal - this.#milestones[currentMilestone].cart_value) / distanceBetweenTwoMilestones * (marginValues[nextMilestone] - marginValues[currentMilestone]);
    } else {
      return this.cartTotal / this.#milestones[nextMilestone].cart_value * marginValues[nextMilestone];
    }
  };
  replaceVariables(string, milestone) {
    const cartValue = milestone.cart_value;
    return string.replace(
      /{{discount}}/g,
      `${cartValue} 
                ${milestone.discount_type === "percentage" ? `${cartValue}%` : this.formatMoney(cartValue * 100, this.#currencyFormat, this.#currencyDisplay)}`
    ).replace(/{{amount}}/g, this.formatMoney((cartValue - this.cartTotal) * 100, this.#currencyFormat, this.#currencyDisplay)).replace(/{{title}}/g, milestone.title);
  }
  getLeftAmountText = () => {
    let milestone = null;
    for (let i = 0; i < this.#milestones.length; i++) {
      if (this.cartTotal < this.#milestones[i].cart_value) {
        milestone = this.#milestones[i];
        break;
      }
    }
    return milestone && this.cartTotal < milestone.cart_value ? this.replaceVariables(milestone.reward_description, milestone) : this.#translation.achieve_all;
  };
  applyDiscountCode = async (discountCodes) => {
    try {
      if (!discountCodes.length)
        return;
      let applyDiscounts = this.appliedDiscounts;
      if (this.#cartGoal.reward_stack === this.CART_GOAL_REWARD_STACK.ALL_MILESTONES) {
        applyDiscounts.push(...discountCodes);
      } else {
        applyDiscounts = discountCodes;
      }
      applyDiscounts = Array.from(new Set(applyDiscounts));
      const otherDiscountsInCart = [];
      const discountsAppInCart = [];
      let newDiscounts = [];
      const cartDataReq = await fetch("/cart.js");
      const cartDataRes = await cartDataReq.json();
      const discountCodeApp = Object.values(this.discountCode);
      cartDataRes.discount_codes.forEach(({ code }) => {
        if (discountCodeApp.includes(code)) {
          discountsAppInCart.push(code);
        } else {
          otherDiscountsInCart.push(code);
        }
      });
      const discountsAppInCartSet = new Set(discountsAppInCart);
      if (!discountCodes.every((code) => discountsAppInCartSet.has(code))) {
        newDiscounts = [...applyDiscounts, ...otherDiscountsInCart];
      }
      if (newDiscounts.length) {
        const response = await this.updateCartDiscountCodes(newDiscounts.splice(0, 5));
      }
      this.appliedDiscounts = applyDiscounts;
      if (!window.TLCustomEventCartGoal) {
        tlProgressBarApplyDiscounts(applyDiscounts);
      } else if (window.TLCustomEventCartGoal === 1) {
        window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-applyDiscounts"));
      }
    } catch (e) {
      console.log("Error when apply discount code", e);
    }
  };
  renderAllCartGoals = () => {
    let customRootElementCartPage = this.#cartDisplay;
    let customRootElementCartDraw = this.#cartDrawDisplay;
    const allCartGoalContainers = document.querySelectorAll(".tl__cart-goal__container__drawer, .tl-custom-cart-goal-container");
    if (allCartGoalContainers.length) {
      allCartGoalContainers.forEach((ele) => ele.remove());
    }
    if (customRootElementCartPage.selector || customRootElementCartDraw.selector) {
      if (customRootElementCartPage.selector) {
        if (customRootElementCartPage.position === "prepend") {
          document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => {
            let htmlObject = document.createElement("div");
            htmlObject.classList.add("tl-custom-cart-goal-container");
            htmlObject.innerHTML = this.renderCartGoal(index);
            ele.prepend(htmlObject);
          });
        } else {
          let position = customRootElementCartPage.position === "before" ? "beforebegin" : "afterend";
          document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => ele.insertAdjacentHTML(position, this.renderCartGoal(index)));
        }
      }
      if (customRootElementCartDraw.selector) {
        let position;
        if (customRootElementCartDraw.position === "prepend") {
          position = "prepend";
          document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => {
            let htmlObject = document.createElement("div");
            htmlObject.classList.add("tl-custom-cart-goal-container");
            htmlObject.innerHTML = this.renderCartGoal(index);
            ele.prepend(htmlObject);
          });
        } else {
          position = customRootElementCartDraw.position === "before" ? "beforebegin" : "afterend";
          document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => ele.insertAdjacentHTML(position, this.renderCartGoal(index)));
        }
      }
    } else {
      const selector = this.cartItems.length ? this.rootSelectorElement : this.rootSelectorElementWithEmptyCart;
      const position = this.cartItems.length ? this.rootSelectorPosition : this.rootSelectorPositionWithEmptyCart;
      console.log(selector, position);
      document.querySelectorAll(selector).forEach((ele, index) => {
        ele.insertAdjacentHTML(position, this.renderCartGoal(index));
      });
    }
    this.addTrackImpressionEvent();
  };
  renderCartGoal = (cartGoalIndex) => {
    if (document.querySelectorAll(this.rootSelectorElement).length || this.#cartDrawDisplay.selector || this.#cartDisplay.selector) {
      let milestonesHTMLInCartDrawer = `
        <div
          class="tl__cart-goal__goal-check-point__drawer"
          style="
            margin-left: 10%;
            z-index: 1;
            border-color: var(--tl__cart-goal__filled-bar-color);
            background-color: var(--tl__cart-goal__filled-bar-color);
          "
        >
          <p class="tl__cart-goal__goal-check-point-value">
            200.00 EUR
          </p>

          <img
            class="tl__cart-goal__milestone-image"
            src="https://cdn.shopify.com/extensions/019b7d6e-954a-7caf-ba20-22011dd41256/salepify-792/assets/cart-goal-free-shipping.svg"
            alt="tl-cart-goal"
            style="
              filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg)
                      brightness(100%) contrast(200%);
              opacity: 1;
            "
          />

          <p class="tl__cart-goal__goal-check-point-title">
            Shipping discount
          </p>
        </div>
      `;
      let closestGoal = -1;
      let marginValues = this.getCartGoalsMarginValues();
      this.#milestones.map((milestone, index) => {
        if (closestGoal === -1 && milestone.cart_value > this.cartTotal) {
          closestGoal = index;
        }
        const imgSrc = milestone.reward_type == this.CART_GOAL_REWARD_TYPE.FREE_GIFT ? this.giftSVG : milestone.reward_type == this.CART_GOAL_REWARD_TYPE.CART_DISCOUNT ? this.discountSVG : this.freeShippingSVG;
        milestonesHTMLInCartDrawer += `
                    <div class="tl__cart-goal__goal-check-point__drawer" 
                        style="margin-left: ${marginValues[index]}%;
                        z-index: 1;
                        border-color: ${(() => this.cartTotal >= milestone.cart_value ? "var(--tl__cart-goal__filled-bar-color)" : "#CCCCCC")()};
                        background-color: ${(() => this.cartTotal >= milestone.cart_value ? "var(--tl__cart-goal__filled-bar-color)" : "#ffffff")()}";
                    >
                        <p class="tl__cart-goal__goal-check-point-value" 
                            style="visibility: ${index === closestGoal ? "visible" : ""};"
                        >
                            ${this.formatMoney(milestone.cart_value * 100, this.#currencyFormat, this.#currencyDisplay)}
                        </p>
                        <img style = "filter: ${(() => this.cartTotal >= milestone.cart_value ? "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(200%)" : "invert(83%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)")()}
                            ;opacity : ${this.#customColor.opacity ? this.#customColor.opacity : 1}
                            "
                            alt="tl-cart-goal" class="tl__cart-goal__milestone-image" src="${imgSrc}"/>
                        <p class="tl__cart-goal__goal-check-point-title" 
                            style="visibility: ${index === closestGoal ? "visible" : ""};"
                        >${milestone.title}</p>
                    </div>
                `;
      });
      let trademarkHTMLInCartDrawer = this.showTrademark ? `
                <p
                    style="
                        display: block !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        position: static !important;
                        transform: none !important;
                        clip-path: none !important;
                        overflow: visible !important;
                        width: auto !important;
                        height: auto !important;
                        max-width: none !important;
                        max-height: none !important;
                        background: none !important;
                        color: #000 !important;
                        font-size: 12px !important;
                        text-align: center !important;
                        margin: 0 !important;
                    "
                >
                    Powered by 
                    <a
                        href="https://apps.shopify.com/partners/tek-labs" 
                        target="_blank"
                        style="
                            display: inline !important;
                            visibility: visible !important;
                            opacity: 1 !important;
                            position: static !important;
                            transform: none !important;
                            clip-path: none !important;
                            overflow: visible !important;
                            width: auto !important;
                            height: auto !important;
                            max-width: none !important;
                            max-height: none !important;
                            background: none !important;
                            color: #000 !important;
                            font-size: 12px !important;
                            text-align: center !important;
                            cursor: pointer !important;
                            text-decoration: underline !important;
                        "
                    >
                        Salepify App
                    </a>
                </p>
                ` : "";
      let cartGoalHTMLInCartDrawer = `
                <div class="tl__cart-goal__container__drawer">
                    ${this.renderCountdown()}
                    <p class="tl__cart-goal__reward-description__drawer">${this.getLeftAmountText(this.#milestones[closestGoal])}</p>
                    <div class="tl__cart-goal__goal-container__drawer">
                        <div class="tl__cart-goal__goal-process__drawer" style="display: block; width: ${this.getProcessBarWidth()}%"></div>
                        ${milestonesHTMLInCartDrawer}
                    </div>
                    <div class="tl__cart-goal__free-gift-container-${cartGoalIndex}" style="width: 100%; color: #303030">
                        ${this.renderReward(cartGoalIndex)}
                    </div>
                    ${trademarkHTMLInCartDrawer}
                </div>
            `;
      return cartGoalHTMLInCartDrawer;
    }
  };
  updateCheckpointColors = () => {
    const allCheckpoints = document.querySelectorAll(".tl__cart-goal__goal-check-point__drawer");
    allCheckpoints.forEach((ele, index) => {
      const milestone = this.#milestones?.[index];
      if (!milestone)
        return;
      const isPassed = this.cartTotal >= milestone.cart_value;
      const filledColor = getComputedStyle(document.documentElement).getPropertyValue("--tl__cart-goal__filled-bar-color").trim();
      const borderColor = isPassed ? filledColor : "#CCCCCC";
      const backgroundColor = isPassed ? filledColor : "#ffffff";
      ele.style.borderColor = borderColor;
      ele.style.backgroundColor = backgroundColor;
    });
  };
  updateAllCartGoals = () => {
    let cartGoalsContainerElements = document.querySelectorAll(".tl__cart-goal__container__drawer");
    if (cartGoalsContainerElements.length) {
      cartGoalsContainerElements.forEach((ele, index) => {
        let rewardsContainer = document.querySelector(`.tl__cart-goal__free-gift-container-${index}`);
        if (rewardsContainer) {
          rewardsContainer.innerHTML = this.updateCartGoal(index);
        }
      });
    } else {
      this.renderAllCartGoals();
    }
  };
  updateCartGoal = (cartGoalIndex) => {
    let processBars = document.querySelectorAll(".tl__cart-goal__goal-process__drawer");
    processBars.forEach((ele) => {
      ele.style.width = `${this.getProcessBarWidth()}%`;
    });
    let titles = document.querySelectorAll(".tl__cart-goal__reward-description__drawer");
    if (titles.length) {
      titles.forEach((ele) => ele.innerHTML = `${this.getLeftAmountText()}`);
    }
    let cartGoalElements = document.querySelectorAll(".tl__cart-goal__goal-check-point__drawer");
    let cartGoalImgElements = document.querySelectorAll(".tl__cart-goal__goal-check-point__drawer img");
    let cartGoalsValueElement = document.querySelectorAll(".tl__cart-goal__goal-check-point-value");
    let cartGoalsTitleElement = document.querySelectorAll(".tl__cart-goal__goal-check-point-title");
    let closestPoint = -1;
    for (let i = 0; i < this.#milestones.length; i++) {
      if (closestPoint === -1 && this.#milestones[i].cart_value > this.cartTotal) {
        closestPoint = i;
      }
      if (this.cartTotal >= this.#milestones[i].cart_value) {
        if (cartGoalElements[i]) {
          cartGoalElements[i].style.borderColor = "var(--tl__cart-goal__filled-bar-color)";
          cartGoalElements[i].style.backgroundColor = "var(--tl__cart-goal__filled-bar-color)";
        }
        if (cartGoalElements[i + this.#milestones.length]) {
          cartGoalElements[i + this.#milestones.length].style.borderColor = "var(--tl__cart-goal__filled-bar-color)";
        }
        if (cartGoalImgElements[i]) {
          cartGoalImgElements[i].style.filter = "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(200%)";
        }
        if (cartGoalImgElements[i + this.#milestones.length]) {
          cartGoalImgElements[i + this.#milestones.length].style.filter = "invert(83%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)";
        }
      } else {
        if (cartGoalElements[i]) {
          cartGoalElements[i].style.borderColor = "#cccccc";
        }
        if (cartGoalElements[i + this.#milestones.length]) {
          cartGoalElements[i + this.#milestones.length].style.borderColor = "#cccccc";
        }
        if (cartGoalImgElements[i]) {
          cartGoalImgElements[i].style.filter = "invert(83%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)";
        }
        if (cartGoalImgElements[i + this.#milestones.length]) {
          cartGoalImgElements[i + this.#milestones.length].style.filter = "invert(83%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)";
        }
      }
      if (cartGoalsValueElement[i]) {
        cartGoalsValueElement[i].style.visibility = "";
      }
      if (cartGoalsValueElement[i + this.#milestones.length]) {
        cartGoalsValueElement[i + this.#milestones.length].style.visibility = "";
      }
      if (cartGoalsTitleElement[i]) {
        cartGoalsTitleElement[i].style.visibility = "";
      }
      if (cartGoalsTitleElement[i + this.#milestones.length]) {
        cartGoalsTitleElement[i + this.#milestones.length].style.visibility = "";
      }
      if (closestPoint === i) {
        if (cartGoalsValueElement[i]) {
          cartGoalsValueElement[i].style.visibility = "visible";
        }
        if (cartGoalsValueElement[i + this.#milestones.length]) {
          cartGoalsValueElement[i + this.#milestones.length].style.visibility = "visible";
        }
        if (cartGoalsTitleElement[i]) {
          cartGoalsTitleElement[i].style.visibility = "visible";
        }
        if (cartGoalsTitleElement[i + this.#milestones.length]) {
          cartGoalsTitleElement[i + this.#milestones.length].style.visibility = "visible";
        }
      }
    }
    return this.renderReward(cartGoalIndex);
  };
  showError(message) {
    const blockErrors = document.querySelectorAll("#salepify-cart-goal-block-error");
    blockErrors.forEach((element) => {
      element.style = "display: flex; align-items: center;";
      element.innerHTML = `
            <svg style="fill: red;" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
            </svg>
            <span id="salepify-cart-goal-block-error__message" style="color: red">${message}</span>
        `;
    });
    setTimeout(() => {
      blockErrors.forEach((element) => {
        element.style = "display: none;";
      });
    }, "3000");
  }
  renderShippingReward = () => {
    const tlCartGoalLocalStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE));
    const aplliedFreeShipping = this.cartGoal.auto_add_reward || tlCartGoalLocalStorage.claimed_shipping_reward;
    const milestone = this.#milestones[this.passedMilestone.freeShipping];
    const afterAchieve = this.replaceVariables(milestone.reward_description_after, milestone);
    return `
            <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
            <div style="display: flex; width: 100%;justify-content: space-between;align-items:center;gap:10px">
                <div>
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${milestone.title}</p>
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
                </div>
                <div style="width: 40%;text-align: center;font-size: 13px; display: flex; justify-content: end">
                
                ${this.#cartGoal.auto_add_reward ? aplliedFreeShipping ? `<div
                        class="tl-cart-goal-apply-free-shipping-btn__cart-drawer"
                        style="width: 100%;background: ${this.#sectionRewardStyle.button_selected_color};
                        color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                        onclick=""
                    >
                        ${this.#translation.auto_apply_btn.shipping_discount}
                    </div>` : `` : `<div 
                        class="tl-cart-goal-apply-free-shipping-btn__cart-drawer"
                        style="width: 100%;background: ${!aplliedFreeShipping ? "var(--tl__cart-goal__section-reward__button-color)" : "var(--tl__cart-goal__section-reward__button-selected-color)"};color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                        onclick="${!aplliedFreeShipping ? `window.tlCartGoalEmbed.handleApplyFreeShippingCode()` : ""}"
                    >
                        ${!aplliedFreeShipping ? `${this.#translation.manual_apply_btn.shipping_discount.before_apply}` : `${this.#translation.manual_apply_btn.shipping_discount.after_apply}`}
                    </div>`}
                
                </div>
            </div>
        `;
  };
  renderCartDcReward = () => {
    const aplliedCartDiscount = this.appliedDiscounts.includes(this.discountCode.order_discount);
    const milestone = this.#milestones[this.passedMilestone.discount];
    const afterAchieve = this.replaceVariables(milestone.reward_description_after, milestone);
    return `
            <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
            <div style="display: flex; width: 100%;justify-content: space-between;align-items:center">
                <div>
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${milestone.title}</p>
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
                </div>
                <div style="width: 40%;text-align: center;font-size: 13px; display: flex; justify-content: end">
                
                ${this.#cartGoal.auto_add_reward ? aplliedCartDiscount ? `<div 
                        class="tl-cart-goal-apply-discount-code-btn__cart-drawer"
                        style="width: 100%;background: ${this.#sectionRewardStyle.button_selected_color};color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                        onclick="">
                            ${this.#translation.auto_apply_btn.order_discount}
                        </div>` : `` : `<div 
                        class="tl-cart-goal-apply-discount-code-btn__cart-drawer"
                        style="width: 100%;background: ${!aplliedCartDiscount ? "var(--tl__cart-goal__section-reward__button-color)" : "var(--tl__cart-goal__section-reward__button-selected-color)"};color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                        onclick="${!aplliedCartDiscount ? `window.tlCartGoalEmbed.handleApplyOrderDiscount()` : ""}"
                        >
                          ${!aplliedCartDiscount ? `${this.#translation.manual_apply_btn.order_discount.before_apply}` : `${this.#translation.manual_apply_btn.order_discount.after_apply}`}
                    </div>`}
                
                </div>
            </div>
        `;
  };
  renderFreeGiftReward = (cartGoalIndex, giftMilestoneIndex) => {
    const milestone = this.#milestones[giftMilestoneIndex];
    const hasAppliedProductDiscount = this.appliedDiscounts.includes(this.discountCode.product_discount);
    const hasGiftMilestone = this.milestoneIndexMapGift.get(giftMilestoneIndex) ?? [];
    const giftsWithDiscount = this.giftsWithDiscount.get(giftMilestoneIndex) || [];
    const totalGiftQuantity = giftsWithDiscount.reduce((sum, gift) => sum + (gift.quantity || 1), 0);
    const milestoneClaimed = totalGiftQuantity == milestone.reward_value;
    const appliedFreeGift = this.#cartGoal.auto_add_reward ? hasAppliedProductDiscount && hasGiftMilestone : hasAppliedProductDiscount && hasGiftMilestone && milestoneClaimed;
    let giftItemHTML = "";
    const giftIndexInGiftsList = this.milestoneIndexInGiftsList.get(giftMilestoneIndex);
    let giftVariants = this.gifts[giftIndexInGiftsList] || [];
    giftVariants.map((variant, variantIndex) => {
      giftItemHTML += `
                <div ${variant.available ? `onClick="window.tlCartGoalEmbed.handleChangeGift(${giftMilestoneIndex}, ${variantIndex})"` : ""}  class="tl__cart-goal__free-gift-reward-body">
                    <div style="display: flex; gap: 16px; align-items: center; ${variant.available ? "" : "opacity:0.4; pointer-events: none;"}">
                        <div class="tl__cart-goal__product-image">
                            <img src="${variant.featured_image.src || variant.featured_image}" alt="product-image"/>
                            <span class="tl__cart-goal__product-quantity">${variant.specificQuantity}</span>
                        </div>
                        <div class="tl__cart-goal__product-image-info">
                            <p>${variant.name}</p>
                           ${variant.available ? `
                            <span><del>${this.formatMoney(variant.price, this.#cartGoal.currency_format, this.#cartGoal.currency_display)}</del></span>
                            <span>${this.#translation.gift_modal.free_text_content}</span>
                            ` : `<span>${this.translation.gift_modal.out_of_stock_msg}</span>`}
                        </div>
                    </div>
                    ${variant.available ? `<div class="tl__cart-goal__check-box tl__cart-goal__check-box-${giftMilestoneIndex} tl__cart-goal__check-box-${giftMilestoneIndex}-${variantIndex}" tl__cart-goal_data_id=${variant.id}></div>` : ``}
                </div>
            `;
    });
    const afterAchieve = this.replaceVariables(milestone.reward_description_after, milestone);
    return `
            <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
            <div style="display: flex; width: 100%;justify-content: space-between;">
                <div style="width: 60%">
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${milestone.title}</p>
                    <p class="tl__cart-goal__container-text-reward" style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
                </div>
                
                ${this.#cartGoal.auto_add_reward && giftVariants.length ? appliedFreeGift ? `<div style="background: ${this.#sectionRewardStyle.button_selected_color}" class="tl__cart-goal__gift-noti">
                    ${this.#translation.auto_apply_btn.gift}
                </div>` : `` : `<div 
                    style="pointer-events: ${appliedFreeGift ? "none" : "auto"}; 
                    background: ${appliedFreeGift ? "var(--tl__cart-goal__section-reward__button-selected-color)" : "var(--tl__cart-goal__section-reward__button-color)"};" 
                    class="tl__cart-goal__gift-noti" 
                    onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, ${giftMilestoneIndex})"
                >
                    <span>
                        ${appliedFreeGift ? this.#translation.manual_apply_btn.gift.after_apply : this.#translation.manual_apply_btn.gift.before_apply}
                    </span>
                </div>`}
                
            </div>
            <div class="tl__cart-goal__gift-modal-${cartGoalIndex}-${giftMilestoneIndex}">
            ${giftVariants.length !== 0 ? `<div class="tl__cart-goal__list-gifts tl__cart-goal__list-gifts-${giftMilestoneIndex}">
                            <span style="font-weight: 500; padding: 8px 0;max-height: 40px;">${this.#translation.gift_modal.title.replace(
      "{{amount}}",
      `${this.#milestones[giftMilestoneIndex].reward_value}`
    )} <span class="tl_selected_quantity"></span></span>
                            <div style="max-height: 300px;overflow-y: auto;width: 100%;display: flex;flex-direction: column;gap: 10px;padding: 8px 5px;margin-bottom: 4px;">
                            ${giftItemHTML}
                            </div>
                            <div id="salepify-cart-goal-block-error"></div>
                            <div style="display: flex; width: 100%;height: 60px; font-size:12px">
                                <div class="tl__cart-goal__button-cancel-gift" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, ${giftMilestoneIndex}, false)">
                                ${this.#translation.gift_modal.cancel_btn}
                                </div>
                                <div class="tl__cart-goal__button-add-gift" onclick="(()=>{window.tlCartGoalEmbed.handleAddtoCart(${giftMilestoneIndex}, ${cartGoalIndex})})()">
                                ${this.#translation.gift_modal.confirm_btn}
                                </div>
                            </div>
                        </div>` : `<div class="tl__cart-goal__list-gifts">
                            <span style="font-weight: 600">Sorry, but there's no gift available</span>
                            <div style="display: flex; width: 100%;height: 60px">
                                <div class="tl__cart-goal__button-cancel-gift" style="width: 100%;" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, ${giftMilestoneIndex}, false)">
                                    ${this.#translation.gift_modal.cancel_btn}
                                </div>
                            </div>
                        </div>`}
            </div>
        `;
  };
  renderReward = (cartGoalIndex) => {
    let innerHTML = "";
    if (!this.#sectionRewardStyle.hide_claim_reward) {
      const { ALL_MILESTONES } = this.CART_GOAL_REWARD_STACK;
      const { FREE_SHIPPING, FREE_GIFT } = this.CART_GOAL_REWARD_TYPE;
      if (this.#cartGoal.reward_stack == ALL_MILESTONES) {
        const shippingRewardHTML = this.passedMilestone.freeShipping !== -1 ? this.renderShippingReward() : "";
        const cartDcRewardHTML = this.passedMilestone.discount !== -1 ? this.renderCartDcReward() : "";
        const freeGiftRewardHTML = this.passedMilestone.gift !== -1 ? this.milestones.map((milestone, index) => {
          if (index <= this.passedMilestone.gift && milestone.reward_type === "gift") {
            return this.renderFreeGiftReward(cartGoalIndex, index);
          }
          return "";
        }).join("") : "";
        innerHTML = `
                ${freeGiftRewardHTML}
                ${cartDcRewardHTML}
                ${shippingRewardHTML}
                `;
      } else if (this.passedMilestone.lastest !== -1) {
        const lastestMileStoneIdx = this.passedMilestone.lastest;
        const lastestMileStone = this.#milestones[lastestMileStoneIdx];
        innerHTML = lastestMileStone.reward_type == FREE_SHIPPING ? this.renderShippingReward() : lastestMileStone.reward_type == FREE_GIFT ? this.renderFreeGiftReward(cartGoalIndex, lastestMileStoneIdx) : this.renderCartDcReward();
      }
    }
    return innerHTML;
  };
  renderCountdown = () => {
    const {
      countdown_timer,
      end_at: end
    } = this.#cartGoal;
    let innerHTML = "";
    const countdownTimer = countdown_timer ? JSON.parse(countdown_timer) : null;
    if (countdownTimer && end) {
      const countdownTranslation = this.#translation.countdown_timer;
      innerHTML = `
                <salepify-countdown class="tl-cart-goal-countdown" endat="${end}" format="${countdownTimer.format}">
                    <div class="tl-cart-goal-countdown__title">
                        ${countdownTranslation.title}
                    </div>
                    <div class="tl-cart-goal-countdown__content">
                        <div class="salepify-countdown-timer" type="days" style="display: ${countdownTimer.format.includes("dd") ? "flex" : "none"}">
                            <span class="salepify-countdown-timer__number">--</span>
                            <span class="salepify-countdown-timer__label">${countdownTranslation.days}</span>
                        </div>

                        <div class="salepify-countdown-timer__separator" style="display: ${countdownTimer.format.includes("dd") ? "block" : "none"}">:</div>

                        <div class="salepify-countdown-timer" type="hours" style="display: ${countdownTimer.format.includes("hh") ? "flex" : "none"}">
                            <span class="salepify-countdown-timer__number">--</span>
                            <span class="salepify-countdown-timer__label">${countdownTranslation.hours}</span>
                        </div>

                        <div class="salepify-countdown-timer__separator" style="display: ${countdownTimer.format.includes("hh") ? "block" : "none"}">:</div>

                        <div class="salepify-countdown-timer" type="minutes" style="display: ${countdownTimer.format.includes("mm") ? "flex" : "none"}">
                            <span class="salepify-countdown-timer__number">--</span>
                            <span class="salepify-countdown-timer__label">${countdownTranslation.minutes}</span>
                        </div>

                        <div class="salepify-countdown-timer__separator" style="display: ${countdownTimer.format.includes("ss") ? "block" : "none"}">:</div>

                        <div class="salepify-countdown-timer" type="seconds" style="display: ${countdownTimer.format.includes("ss") ? "flex" : "none"}">
                            <span class="salepify-countdown-timer__number">--</span>
                            <span class="salepify-countdown-timer__label">${countdownTranslation.seconds}</span>
                        </div>
                    </div>
                </salepify-countdown>
            `;
    }
    return innerHTML;
  };
  getDataFromAjax = async () => {
    let cartJsResponse = await fetch("/cart.js");
    let cartData = await cartJsResponse.json();
    this.cartItems = cartData.items;
    const validItem = cartData.items.find((item) => !isNaN(item.price / item.presentment_price));
    const ratio = validItem ? validItem.price / validItem.presentment_price : 1;
    const progressBarDiscount = Object.values(this.discountCode);
    this.appliedDiscounts = cartData.discount_codes.filter((discount) => progressBarDiscount.includes(discount.code)).map((discount) => discount.code);
    let totalAmount = 0;
    let triggerConditionIds = JSON.parse(this.#cartGoal.trigger_condition_ids);
    triggerConditionIds = triggerConditionIds.map((a) => a.shopify_id);
    if (this.#cartGoal.trigger_condition == this.TRIGGER_CONDITION.PRODUCT) {
      cartData.items.forEach((item) => {
        const productId = String(item.product_id);
        const isValidItem = !this.checkIsGift(item) && triggerConditionIds.includes(productId) && this.checkPurchaseType(item);
        if (isValidItem) {
          totalAmount += this.getItemPrice(item) / ratio;
        }
        this.itemIdsInCart.push(String(item.id));
      });
    } else if (this.#cartGoal.trigger_condition == this.TRIGGER_CONDITION.COLLECTION) {
      const setCollectionIds = new Set(triggerConditionIds);
      cartData.items.forEach((item) => {
        const productId = String(item.product_id);
        let collections = this.productIdMapCollection.get(productId);
        const isValidItem = !this.checkIsGift(item) && collections.some((id) => setCollectionIds.has(id)) && this.checkPurchaseType(item);
        if (isValidItem) {
          totalAmount += this.getItemPrice(item) / ratio;
        }
        this.itemIdsInCart.push(String(item.id));
      });
    } else {
      cartData.items.forEach((item) => {
        const isValidItem = !this.checkIsGift(item) && this.checkPurchaseType(item);
        if (isValidItem) {
          totalAmount += this.getItemPrice(item) / ratio;
        }
        this.itemIdsInCart.push(String(item.id));
      });
    }
    await this.assignCartTotal(totalAmount);
    let giftIndex = 0;
    let milestonesHaveGifts = this.#milestones.filter((milestone, index) => {
      if (JSON.parse(milestone.gifts).length) {
        this.milestoneIndexInGiftsList.set(index, giftIndex++);
        return true;
      }
      return false;
    });
    let giftsData = milestonesHaveGifts.map((milestone) => JSON.parse(milestone.gifts));
    const data = milestonesHaveGifts.map((milestone) => JSON.parse(milestone.gifts));
    let listHandle = [];
    giftsData.map((arr) => listHandle = [...listHandle, ...arr]);
    let formattedGiftsData = [];
    listHandle = Array.from(new Set(listHandle.map((item) => item.handle)));
    try {
      const getFirstProduct = await fetch(window.Shopify.routes.root + `products/${listHandle[0]}.js`);
      const routes = getFirstProduct.ok ? window.Shopify.routes.root : "/";
      let allGiftVariantsData = await Promise.all(listHandle.map(async (item) => {
        let res = await fetch(routes + `products/${item}.js`);
        if (res.ok) {
          return await res.json();
        } else {
          return null;
        }
      }));
      const validAllGiftVariantsData = allGiftVariantsData.filter((product) => product !== null);
      giftsData.map((gifts, index) => {
        formattedGiftsData.push([]);
        gifts.map((gift, idx) => {
          validAllGiftVariantsData.map((product) => {
            if (gift.handle === product.handle) {
              product.variants.map((variant) => {
                if (gift.id.includes(variant.id)) {
                  variant.specificQuantity = data[index][idx].specificQuantity;
                  if (!variant.featured_image) {
                    if (product.featured_image) {
                      variant.featured_image = product.featured_image.src ? product.featured_image.src : product.featured_image;
                    } else {
                      variant.featured_image = this.defaultImage;
                    }
                  }
                  formattedGiftsData[index].push(JSON.parse(JSON.stringify(variant)));
                }
              });
            }
          });
        });
      });
      this.gifts = [...formattedGiftsData];
    } catch (e) {
      console.log("Error when format gifts data:", e);
    }
  };
  getPassedMilestone = async (cartTotal = this.cartTotal, firstLoad = false) => {
    const passedMilestone = {
      gift: -1,
      indexOfPassedFreeGift: -1,
      freeShipping: -1,
      discount: -1,
      lastest: -1
    };
    this.#milestones.map((milestone, index) => {
      if (milestone.cart_value <= cartTotal) {
        passedMilestone.lastest = index;
        switch (milestone.reward_type) {
          case this.CART_GOAL_REWARD_TYPE.FREE_GIFT:
            passedMilestone.gift = index;
            passedMilestone.indexOfPassedFreeGift++;
            break;
          case this.CART_GOAL_REWARD_TYPE.CART_DISCOUNT:
            passedMilestone.discount = index;
            break;
          case this.CART_GOAL_REWARD_TYPE.FREE_SHIPPING:
            passedMilestone.freeShipping = index;
            break;
        }
      }
    });
    const oldPassedMilestone = firstLoad && this.cartType !== "page" && this.is_cart_auto_update ? passedMilestone : JSON.parse(JSON.stringify(this.passedMilestone));
    this.passedMilestone = passedMilestone;
    let needToRefresh = false;
    if (this.#cartGoal.auto_remove_gift) {
      needToRefresh = await this.handleRemoveGift();
    }
    const isAllMilestoneStack = this.#cartGoal.reward_stack === this.CART_GOAL_REWARD_STACK.ALL_MILESTONES;
    const {
      product_discount: productDc,
      order_discount: orderDc
    } = this.discountCode;
    const discountCodes = [];
    if (this.#cartGoal.auto_add_reward) {
      if (isAllMilestoneStack && oldPassedMilestone.lastest < passedMilestone.lastest) {
        if (passedMilestone.gift !== -1) {
          if (!this.milestoneIndexMapGift.get(passedMilestone.gift)) {
            const listMilestoneNeedAutoAdd = [];
            this.#milestones.forEach((milestone, milestoneIndex) => {
              if (milestone.reward_type === this.CART_GOAL_REWARD_TYPE.FREE_GIFT && milestoneIndex <= passedMilestone.gift && !this.milestoneIndexMapGift.has(milestoneIndex)) {
                listMilestoneNeedAutoAdd.push(milestoneIndex);
              }
            });
            await this.handleAutoAddMultipleGift(listMilestoneNeedAutoAdd);
          } else if (!this.appliedDiscounts.includes(productDc)) {
            discountCodes.push(productDc);
          }
        }
        if (passedMilestone.discount !== -1 && !this.appliedDiscounts.includes(orderDc)) {
          discountCodes.push(orderDc);
        }
      } else if (passedMilestone.lastest !== oldPassedMilestone.lastest) {
        if (passedMilestone.lastest == -1) {
          needToRefresh = true;
        } else {
          if (passedMilestone.gift == passedMilestone.lastest) {
            if (!this.milestoneIndexMapGift.get(passedMilestone.gift)) {
              await this.handleAutoAddMultipleGift([passedMilestone.gift]);
            } else if (!this.appliedDiscounts.includes(productDc)) {
              discountCodes.push(productDc);
            }
          } else if (passedMilestone.discount == passedMilestone.lastest && !this.appliedDiscounts.includes(orderDc)) {
            discountCodes.push(orderDc);
          } else if (passedMilestone.freeShipping == passedMilestone.lastest && !firstLoad) {
            needToRefresh = true;
          }
        }
      }
    }
    if (needToRefresh || discountCodes.length) {
      await this.applyDiscountCode(discountCodes);
      if (!window.TLCustomEventCartGoal) {
        await tlHandleReRenderCart(false);
      } else if (window.TLCustomEventCartGoal == 1) {
        window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-getPassedMilestone"));
      }
    }
  };
  toggleGifts = (cartGoalIndex, giftMilestoneIndex, isOpen = true) => {
    let selector = `.tl__cart-goal__gift-modal-${cartGoalIndex}-${giftMilestoneIndex}`;
    let modal = document.querySelector(selector);
    if (modal) {
      if (isOpen) {
        this.renderSelectedGift(giftMilestoneIndex, cartGoalIndex);
        modal.style.display = "block";
        this.getQuantitySelected(giftMilestoneIndex);
      } else {
        modal.style.display = "none";
      }
    }
  };
  renderSelectedGift = (index, cartGoalIndex) => {
    let checkBoxes = document.querySelectorAll(`.tl__cart-goal__gift-modal-${cartGoalIndex}-${index} .tl__cart-goal__check-box-${index}`);
    checkBoxes.forEach((ele) => ele.classList.remove("tl__cart-goal__check-box--active"));
    const giftArr = this.milestoneIndexMapGift.get(index) || [];
    checkBoxes.forEach((ele) => {
      const dataId = ele.getAttribute("tl__cart-goal_data_id");
      const isInMap = giftArr.some((item) => item.id == dataId);
      if (isInMap) {
        ele.classList.add("tl__cart-goal__check-box--active");
      }
    });
    if (!this.milestoneIndexMapGift.has(index)) {
      this.milestoneIndexMapGift.set(index, []);
    }
    checkBoxes.forEach((ele) => {
      new Set(this.milestoneIndexMapGift.get(index)).forEach((item) => {
        if (item.id == ele.getAttribute("tl__cart-goal_data_id")) {
          ele.classList.add("tl__cart-goal__check-box--active");
        }
      });
    });
    this.position[this.passedMilestone.gift] = [];
    for (let i = 0; i < this.gifts[this.passedMilestone.indexOfPassedFreeGift].length; i++) {
      this.itemIdsInCart.forEach((item) => {
        if (item == this.gifts[this.passedMilestone.indexOfPassedFreeGift][i].id) {
          this.position[this.passedMilestone.gift].push(i);
        }
      });
    }
  };
  getQuantitySelected = (giftMilestoneIndex) => {
    let countQuantity = 0;
    let giftsData = JSON.parse(this.#milestones[giftMilestoneIndex].gifts);
    const activeCheckboxes = document.querySelectorAll(
      `.tl__cart-goal__check-box-${giftMilestoneIndex}.tl__cart-goal__check-box--active`
    );
    this.position[giftMilestoneIndex] = Array.from(new Set(
      Array.from(activeCheckboxes).map((el) => {
        const cls = Array.from(el.classList).find(
          (c) => c.startsWith(`tl__cart-goal__check-box-${giftMilestoneIndex}-`)
        );
        const indexStr = cls?.split(`tl__cart-goal__check-box-${giftMilestoneIndex}-`)[1];
        const index = parseInt(indexStr, 10);
        return index;
      }).filter((i) => !isNaN(i))
    ));
    this.position[giftMilestoneIndex].forEach((item) => {
      countQuantity += giftsData[item].specificQuantity ? giftsData[item].specificQuantity : 1;
    });
    const selectedQuantitys = document.querySelectorAll(".tl_selected_quantity");
    selectedQuantitys.forEach((element) => {
      if (countQuantity > this.#milestones[giftMilestoneIndex].reward_value) {
        element.style = "border-radius: 40%; padding: 3px; background: #E8E7EC; font-weight: 600; color: red";
      } else {
        element.style = "border-radius: 40%; padding: 3px; background: #E8E7EC; font-weight: 600; color: black";
      }
      element.innerHTML = `${countQuantity}/${this.#milestones[giftMilestoneIndex].reward_value}`;
    });
  };
  handleChangeGift = (index, variantIndex) => {
    if (!this.position[index]) {
      this.position[index] = [];
    }
    let existedIndex = this.position[index].indexOf(variantIndex);
    if (existedIndex !== -1) {
      this.position[index].splice(existedIndex, 1);
    } else {
      this.position[index].push(variantIndex);
    }
    let selectedBoxs = document.querySelectorAll(`.tl__cart-goal__check-box-${index}-${variantIndex}`);
    selectedBoxs.forEach((ele) => {
      if (ele.classList.contains("tl__cart-goal__check-box--active")) {
        ele.classList.remove("tl__cart-goal__check-box--active");
      } else {
        ele.classList.add("tl__cart-goal__check-box--active");
      }
    });
    this.getQuantitySelected(index);
  };
  handleAutoAddMultipleGift = async (listIndex) => {
    try {
      const items = [];
      listIndex.forEach((index) => {
        let giftsData = JSON.parse(this.#milestones[index].gifts);
        giftsData.forEach((gift) => {
          const itemId = gift.id.split("/")[4];
          items.push({
            "id": itemId,
            "quantity": this.#milestones[index].specific_quantity ? gift.specificQuantity : 1,
            "properties": { [this.PROPERTY]: `${this.#cartGoal.id}-${index}` }
          });
        });
        this.milestoneIndexMapGift.delete(index);
      });
      if (items.length) {
        await this.applyDiscountCode([this.discountCode.product_discount]);
        const request = await fetch(window.Shopify.routes.root + "cart/add.js?app=salepify", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            "items": items
          })
        });
        if (request.status == 200) {
          const response = await request.json();
          response.items.forEach((item) => this.checkIsGift({ ...item, final_price: 0 }));
          if (!window.TLCustomEventCartGoal) {
            await tlHandleReRenderCart(true);
          } else if (window.TLCustomEventCartGoal == 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-handleAutoAddGift"));
          }
        }
      }
    } catch (e) {
      console.log("Error when auto add to cart", e);
    }
  };
  handleAddtoCart = async (milestoneIndex, cartGoalIndex) => {
    try {
      const buttons = document.querySelectorAll(".tl__cart-goal__button-add-gift");
      buttons.forEach((ele) => {
        ele.innerHTML = `<div class="tl-cart-goal-loader"></div>`;
        ele.onclick = null;
      });
      let giftsData = JSON.parse(this.#milestones[milestoneIndex].gifts);
      let countQuantity = 0;
      const items = [];
      const listItemsIds = [];
      this.position[milestoneIndex] = Array.from(new Set(this.position[milestoneIndex]));
      this.position[milestoneIndex].map((item) => {
        countQuantity += giftsData[item].specificQuantity ? giftsData[item].specificQuantity : 1;
      });
      let listSelected = document.querySelectorAll(`.tl__cart-goal__gift-modal-${cartGoalIndex}-${milestoneIndex} .tl__cart-goal__check-box--active`);
      listSelected.forEach((ele) => {
        if (ele.getAttribute("tl__cart-goal_data_id")) {
          listItemsIds.push(ele.getAttribute("tl__cart-goal_data_id"));
        }
      });
      this.position[milestoneIndex] = [];
      listItemsIds.forEach((itemId) => {
        for (let i = 0; i < giftsData.length; i++) {
          if (giftsData[i].id.split("/")[4] == itemId) {
            this.position[milestoneIndex].push(i);
          }
        }
      });
      const milestone = this.#milestones[milestoneIndex];
      const positionItems = this.position[milestoneIndex];
      await this.handleRemoveGift(milestoneIndex);
      const addedGifts = this.milestoneIndexMapGift.get(milestoneIndex) ?? [];
      const addedGiftIds = addedGifts.map((g) => g.id.toString());
      let newListItemIdsInCart = [];
      for (const item of positionItems) {
        const gift = giftsData[item];
        const itemId = gift.id.split("/")[4];
        const quantity = milestone.specific_quantity ? gift.specificQuantity : 1;
        if (!addedGiftIds.includes(itemId)) {
          items.push({
            id: itemId,
            quantity,
            properties: { [this.PROPERTY]: `${this.#cartGoal.id}-${milestoneIndex}` }
          });
          newListItemIdsInCart.push(itemId);
        }
      }
      this.itemIdsInCart = newListItemIdsInCart;
      if (countQuantity <= this.#milestones[milestoneIndex].reward_value) {
        if (this.#cartGoal.reward_stack === this.CART_GOAL_REWARD_STACK.ONLY_LASTEST_MILESTONE) {
          await this.handleRemoveGift();
        }
        await this.applyDiscountCode([this.discountCode.product_discount]);
        if (items.length) {
          const request = await fetch(window.Shopify.routes.root + "cart/add.js?app=salepify", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              "items": items
            })
          });
          if (request.status == 200) {
            const response = await request.json();
            response.items.forEach((item) => this.checkIsGift({ ...item, final_price: 0 }));
          }
        }
        if (!window.TLCustomEventCartGoal) {
          await tlHandleReRenderCart(true);
        } else if (window.TLCustomEventCartGoal == 1) {
          window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-handleAddtoCart"));
        }
      } else {
        this.showError(this.#translation.gift_modal.warning_msg.replace("{{amount}}", `${this.#milestones[this.passedMilestone.gift].reward_value}`));
        const passedFreeGift = this.passedMilestone.gift;
        buttons.forEach((ele) => {
          ele.innerHTML = this.#translation.gift_modal.confirm_btn;
          ele.onclick = function() {
            window.tlCartGoalEmbed.handleAddtoCart(passedFreeGift, cartGoalIndex);
          };
        });
      }
    } catch (e) {
      console.log("Error when add to cart", e);
    }
  };
  handleRemoveGift = async (milestoneIndexNeedRemoveGift) => {
    const isAllMilestoneStack = this.#cartGoal.reward_stack === this.CART_GOAL_REWARD_STACK.ALL_MILESTONES;
    const targetIndex = isAllMilestoneStack ? this.passedMilestone.gift : this.passedMilestone.lastest;
    let updates = {};
    const milestoneNeedToRm = [];
    try {
      if (typeof milestoneIndexNeedRemoveGift === "number" && milestoneIndexNeedRemoveGift >= 0) {
        const gifts = this.milestoneIndexMapGift.get(milestoneIndexNeedRemoveGift) ?? [];
        if (gifts.length) {
          milestoneNeedToRm.push(milestoneIndexNeedRemoveGift);
          gifts.forEach((gift) => updates[gift.key] = 0);
        }
        this.giftsWithDiscount.delete(milestoneIndexNeedRemoveGift);
      } else {
        Array.from(this.milestoneIndexMapGift).forEach(([milestoneIndex, gifts]) => {
          const shouldRemove = isAllMilestoneStack ? milestoneIndex > targetIndex : milestoneIndex !== targetIndex;
          if (shouldRemove) {
            milestoneNeedToRm.push(milestoneIndex);
            gifts.forEach((gift) => updates[gift.key] = 0);
          }
        });
      }
      if (this.#cartGoal.auto_remove_gift && Object.entries(this.giftWithoutDiscount).length) {
        updates = {
          ...this.giftWithoutDiscount,
          ...updates
        };
        this.milestoneIndexMapGift.forEach((gifts, milestoneIndex) => {
          const remainingGifts = gifts.filter((gift) => !(gift.key in this.giftWithoutDiscount));
          remainingGifts.length > 0 ? this.milestoneIndexMapGift.set(milestoneIndex, remainingGifts) : this.milestoneIndexMapGift.delete(milestoneIndex);
        });
        this.giftWithoutDiscount = {};
      }
      if (Object.entries(updates).length) {
        await fetch(window.Shopify.routes.root + "cart/update.js?app=salepify", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ updates })
        });
        milestoneNeedToRm.forEach((index) => this.milestoneIndexMapGift.delete(index));
        return true;
      }
      return false;
    } catch (error) {
      console.log("Error when handleRemoveGift: ", error);
    }
  };
  handleApplyOrderDiscount = async () => {
    try {
      let selector = ".tl-cart-goal-apply-discount-code-btn__cart-drawer";
      document.querySelectorAll(selector).forEach((ele) => {
        ele.innerHTML = `
                    <div 
                        style="width: 100%;
                        background: var(--tl__cart-goal__section-reward__button-color);
                        color: white;font-size: 14px;
                        border-radius: 5px;
                        display:flex;
                        justify-content: center;
                        align-items: center;"
                    >
                        <div class="tl-cart-goal-loader"></div>
                    </div>
                `;
        ele.style.pointerEvents = "none";
      });
      await this.applyDiscountCode([this.discountCode.order_discount]);
      if (this.#cartGoal.reward_stack === this.CART_GOAL_REWARD_STACK.ONLY_LASTEST_MILESTONE) {
        await this.handleRemoveGift();
      }
      if (!window.TLCustomEventCartGoal) {
        await tlHandleReRenderCart(false);
      } else if (window.TLCustomEventCartGoal == 1) {
        window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-handleApplyOrderDiscount"));
      }
    } catch (e) {
      console.log("Error when apply discount code", e);
    }
  };
  handleApplyFreeShippingCode = async () => {
    try {
      let selector = ".tl-cart-goal-apply-free-shipping-btn__cart-drawer";
      document.querySelectorAll(selector).forEach((ele) => {
        ele.innerHTML = `
                            <div style="width: 100%;
                                background: var(--tl__cart-goal__section-reward__button-color);
                                color: white;font-size: 14px;
                                border-radius: 5px;
                                display:flex;
                                justify-content: center;
                                align-items: center;"
                            >
                                <div class="tl-cart-goal-loader"></div>
                            </div>`;
        ele.style.pointerEvents = "none";
      });
      if (this.#cartGoal.reward_stack === this.CART_GOAL_REWARD_STACK.ONLY_LASTEST_MILESTONE) {
        await this.handleRemoveGift();
      }
      let tlCartGoalLocalStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE));
      localStorage.setItem(LOCAL_STORAGE, JSON.stringify({
        ...tlCartGoalLocalStorage,
        claimed_shipping_reward: true
      }));
      if (!window.TLCustomEventCartGoal) {
        await tlHandleReRenderCart(true);
      } else if (window.TLCustomEventCartGoal == 1) {
        window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-handleApplyFreeShippingCode"));
      }
    } catch (e) {
      console.log("Error when apply free shipping code", e);
    }
  };
  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  deepMergeObject(a, b) {
    const result = { ...a };
    for (const key in b) {
      if (b.hasOwnProperty(key)) {
        if (a && typeof a[key] === "object" && typeof b[key] === "object" && !Array.isArray(a[key])) {
          result[key] = this.deepMergeObject(a[key], b[key]);
        } else if (b[key] !== void 0) {
          result[key] = b[key];
        }
      }
    }
    return result;
  }
  formatMoney = function(t, currencyFormat, currencyDisplay) {
    const regex = /\{\{amount\}\}/;
    var e;
    if (currencyDisplay?.[this.currency]?.display_format && regex.test(currencyDisplay[this.currency].display_format)) {
      e = currencyDisplay[this.currency].display_format.replace("{{amount}}", currencyFormat ? `{{${currencyFormat}}}` : "{{amount_with_period_and_space_separator}}");
    } else {
      e = currencyFormat ? `{{${currencyFormat}}}${this.currency}` : `{{amount_with_period_and_space}}${this.currency}`;
    }
    function n(t2, e2) {
      return void 0 === t2 ? e2 : t2;
    }
    function o(t2, e2, o2, i2) {
      if (e2 = n(e2, 2), o2 = n(o2, ","), i2 = n(i2, "."), isNaN(t2) || null == t2)
        return 0;
      var r2 = (t2 = (t2 / 100).toFixed(e2)).split(".");
      return r2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o2) + (r2[1] ? i2 + r2[1] : "");
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var i = "", r = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format;
    switch (a.match(r)[1]) {
      case "amount":
        i = o(t, 2);
        break;
      case "amount_no_decimals":
        i = o(t, 0);
        break;
      case "amount_with_comma_separator":
        i = o(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        i = o(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        i = o(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = o(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        i = o(t, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        i = o(t, 2, "'", ".");
    }
    return a.replace(r, i);
  };
  filterRule = async (listRule) => {
    for (let i = listRule.length - 1; i >= 0; i--) {
      const cartGoalRule = listRule[i];
      if (cartGoalRule.status && await this.checkAdvancedCondition(cartGoalRule.advanced_conditions) && this.checkActiveDate(cartGoalRule.start_at, cartGoalRule.end_at)) {
        this.#cartGoal = cartGoalRule;
        break;
      }
    }
  };
  checkActiveDate = (startAt, endAt) => {
    let activeDate = false;
    if (new Date(startAt) <= /* @__PURE__ */ new Date()) {
      if (endAt) {
        if (new Date(endAt) > /* @__PURE__ */ new Date()) {
          activeDate = true;
        }
      } else {
        activeDate = true;
      }
    }
    return activeDate;
  };
  checkAdvancedCondition = async (advancedConditions) => {
    if (advancedConditions && this.isJson(advancedConditions)) {
      const { INCLUDE, EXCLUDE } = this.INCLUSION_TYPE;
      const {
        specific_country: specificCountry,
        specific_locale: specificLocales,
        customer_tag: customerTag,
        customer_status: customerStatus
      } = JSON.parse(advancedConditions);
      if (specificCountry) {
        const { country } = await this.getAndUpdateCartLocation();
        if (specificCountry.type == INCLUDE && !specificCountry.value.includes(country) || specificCountry.type == EXCLUDE && specificCountry.value.includes(country)) {
          return false;
        }
      }
      if (specificLocales) {
        const isLocaleIncluded = specificLocales.value.includes(this.locale);
        if (specificLocales.type === INCLUDE && !isLocaleIncluded || specificLocales.type === EXCLUDE && isLocaleIncluded) {
          return false;
        }
      }
      if (customerStatus) {
        const { LOGGED_IN, NOT_LOGGED } = this.CUSTOMER_STATUS;
        if (customerStatus == LOGGED_IN && !this.customer || customerStatus == NOT_LOGGED && this.customer) {
          return false;
        }
      }
      if (customerTag) {
        let customerTags = this.customer ? this.customer.tags : [];
        customerTags = customerTags.map((tag) => tag.toLowerCase());
        const targetTags = customerTag.value.map((tag) => tag.toLowerCase());
        const isContainTag = targetTags.some((tag) => customerTags.includes(tag));
        if (customerTag.type == INCLUDE && (!isContainTag || !this.customer) || customerTag.type == EXCLUDE && isContainTag) {
          return false;
        }
      }
    }
    return true;
  };
  async getAndUpdateCartLocation() {
    try {
      if (!this.infoLocation) {
        const ipInfoReq = await fetch("https://ipinfo.io/json");
        const ipInfoRes = await ipInfoReq.json();
        const country = ipInfoRes?.country || "";
        const regionNorm = this.normalizeProvinceName ? this.normalizeProvinceName(ipInfoRes?.region || "") : ipInfoRes?.region || "";
        this.infoLocation = { country, region: regionNorm };
        const locationValue = `${this.infoLocation.country}-${this.infoLocation.region}`;
        const request = await fetch(
          window.Shopify.routes.root + "cart/update.js?app=salepify",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              attributes: {
                "_salepify-location": locationValue
              }
            })
          }
        );
        return { country, region: regionNorm };
      } else {
        return this.infoLocation;
      }
    } catch (error) {
      console.error("Failed to get or update cart location:", error);
      return null;
    }
  }
  checkIsGift(item) {
    const property = item.properties[this.PROPERTY];
    if (property) {
      const [ruleId, milestoneIndex] = property.split("-");
      const giftData = this.milestoneIndexMapGift.get(Number(milestoneIndex)) ?? [];
      this.milestoneIndexMapGift.set(Number(milestoneIndex), [...giftData, {
        id: item.id,
        key: item.key,
        quantity: item.quantity
      }]);
      if (item.final_price == 0 && ruleId == this.#cartGoal.id) {
        const currentGiftIds = this.giftsWithDiscount.get(parseInt(milestoneIndex)) || [];
        const isExist = currentGiftIds.some((gift) => gift.key === item.key);
        if (!isExist) {
          this.giftsWithDiscount.set(
            parseInt(milestoneIndex),
            [...currentGiftIds, {
              id: item.id,
              key: item.key,
              quantity: item.quantity
            }]
          );
        }
        return true;
      } else {
        this.giftWithoutDiscount[item.key] = 0;
      }
    }
    return false;
  }
}

const overrideCartGoalEmbed = () => {
    if (!window.tlCartGoalEmbed) {
        return;
    }

    clearInterval(intervalId);
    window.tlCartGoalEmbed = new CartGoalEmbedNew(
        tlCartGoalIsRestricted,
        tlCartGoalRules,
        tlCartGoalGiftSVG,
        tlCartGoalDiscountSVG,
        tlCartGoalFreeShippingSVG,
        tlCartGoalCurrencySymbol,
        tlCartGoalCartTotal,
        tlCartGoalTemplate,
        tlCartGoalDefaultImage,
        tlCartGoalShowTrademark,
        tlCartGoalProductIdMapCollection,
        tlCartGoalDisplaySetting,
        tlCartGoalTranslation,
        tlCartGoalCustomer,
        tlCartGoalCartType,
        tlCartGoalPriceCalculation
    )
}

const intervalId = setInterval(overrideCartGoalEmbed, 50);

setTimeout(() => {
    clearInterval(intervalId);
}, 3000);